import { combineReducers } from "redux";
import videoReducer from "./videoReducer";
import themeReducer from "./themeReducer";
var stdin_default = combineReducers({
  video: videoReducer,
  theme: themeReducer
});
export {
  stdin_default as default
};
